/**
 * Utility functions for ownership checks
 */

/**
 * Check if the current user is the author of a comment
 * @param {Object} comment - The comment object
 * @param {Object} user - The authenticated user object
 * @param {Object} shareData - The share data for shared access (contains email from share link)
 * @returns {boolean} True if the current user (authenticated) or shared user is the author
 */
export function isCommentAuthor(comment, user, shareData) {
  // Prefer shared access identity when available
  if (typeof comment?.user_id !== "undefined") {
    if (shareData?.id != null) {
      return Number(comment.user_id) === Number(shareData.id);
    }
    if (user?.id != null) {
      return Number(comment.user_id) === Number(user.id);
    }
  }

  return false;
}

/**
 * Check if the current user is the author of a question
 * @param {Object} question - The question object
 * @param {Object} user - The authenticated user object
 * @param {Object} shareData - The share data for shared access (unused here)
 * @returns {boolean} True if the current authenticated user authored the question
 */
export function isQuestionAuthor(question, user, shareData) {
  // Prefer explicit created_by_user_id if available
  if (typeof question?.created_by_user_id !== "undefined") {
    if (shareData?.id != null) {
      return Number(question.created_by_user_id) === Number(shareData.id);
    }
    if (user?.id != null) {
      return Number(question.created_by_user_id) === Number(user.id);
    }
    return false;
  }

  // Fallback to possible legacy field created_by_id
  if (typeof question?.created_by_id !== "undefined") {
    if (shareData?.id != null) {
      return Number(question.created_by_id) === Number(shareData.id);
    }
    if (user?.id != null) {
      return Number(question.created_by_id) === Number(user.id);
    }
  }

  return false;
}
